import { render } from "./Benchmark.vue?vue&type=template&id=31c8778b&scoped=true"
import script from "./Benchmark.vue?vue&type=script&lang=js"
export * from "./Benchmark.vue?vue&type=script&lang=js"

import "./Benchmark.vue?vue&type=style&index=0&id=31c8778b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c8778b"]])

export default __exports__